_ = require 'underscore'
{ PowerUpItemType } = require 'app/common/components/power-up'
BaseDirectoryView = require './base-directory-view'
DirectoryPluginItemView = require './directory-plugin-item-view'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('directory')

class DirectoryPageComponent extends React.Component
  displayName: 'Directory Page'

  render: t.renderable ->
    t.div '.directory-content-body', =>
      t.div '.directory-listing'

module.exports = class DirectoryCategoryView extends BaseDirectoryView
  eventSource: ->
    { title } = @options
    if title == 'custom'
      'boardDirectoryCustomScreen'
    else
      'boardDirectoryCategoryScreen'

  renderContent: ->
    React.createElement DirectoryPageComponent, {
      title: @options.title
    }

  render: ->
    super
    contentContainer = @$el.find('.directory-listing')
    contentContainer.empty()

    { plugins, currentPage, directoryView, title } = @options

    pluginViews = _.map plugins, (plugin) =>
      @subview(DirectoryPluginItemView, @model, {
        atomType: PowerUpItemType.Description,
        currentPage,
        plugin,
        directoryView
      }, plugin.id)

    @appendSubviews(pluginViews, contentContainer)

    enabledPlugins = directoryView.getEnabledPlugins()
    listedPowerUpsEnabled = _.intersection(_.map(plugins, 'id'), _.map(enabledPlugins, 'id'))

    eventPayload =
      totalListed: plugins.length
      totalListedEnabled: listedPowerUpsEnabled.length
      totalEnabled: enabledPlugins.length
      allPowerUpsEnabled: _.map(enabledPlugins, 'id')
      listedPowerUpsEnabled: listedPowerUpsEnabled

    eventName = @eventSource()
    eventPayload.categoryid = title unless title == 'custom'

    directoryView.trackScreenEvent eventName, eventPayload

    @
